// The user dismissed the passkey prompt, it timed out, or it was aborted
// because another ceremony (e.g. a manual sign-in) superseded it -- none of
// which are real failures worth an error banner. Thrown by
// createPasskeyCredential/getPasskeyAssertion in ./passkeys.
export default class PasskeyCancelledError extends Error {}
